<template>
  <div class="ad">
    <div class="ad">
      <img :src="sideAdvert.imageUrl" alt="" width="100%"
            @click="intoAdvert(sideAdvert)">
    </div>

    <div class="module-title">今日推荐</div>
    <div v-if="!firstRecommend.id" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
    <div class="recommend" v-else>
      <div class="first link"
            @click="detailInfo(firstRecommend)">
        <img :src="firstRecommend.coverImage" alt="" width="100%">
        <div class="recommend-li">{{firstRecommend.title}}</div>
      </div>
      <div class="recommend-li link" 
            v-for="(item, i) in recommendData" 
            :key="i"
            @click="detailInfo(item)">
        <span>{{i + 1}}</span>{{item.title}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      sideAdvert: {},
      firstRecommend: {},
      recommendData: [],
    }
  },
  mounted () {
    this.getRecommendData()
    this.getAdvert()
  },
  methods: {
    getRecommendData () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 10,
          data: {
            isRecommend: true
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          this.firstRecommend = array[0] || {}
          this.recommendData = array.splice(1)
        }
      })
    },
    getAdvert () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/bannerConfig/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 1,
          data: {
            position: 2 // 侧边栏
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          this.sideAdvert = array[0] || {}
        }
      })
    },
    detailInfo (item) {
      const routeUrl = this.$router.resolve({
        path: '/info',
        query: {id: item.id}
      })
      window.open(routeUrl.href, '_blank')
    },
    intoAdvert (ad) {
      let url = ad.linkUrl
      if (!url) return 
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'http://' + url
      }
      window.open(url, ad.linkTarget === 1 ? '_self' : '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.module-title{
    font-size: 24px;
    margin: 10px 0 20px;
    color: #000;
    span{
      font-size: 14px;
      float: right;
    }
  }
  .ad{
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/components/sidebar.vue